import React from 'react'

import Initializer from './Initializer'
import { Layout, Step } from './components'

const OngageUnsubscribe = () => {
  return (
    <Initializer>
      <Layout>
        <Step />
      </Layout>
    </Initializer>
  )
}

export default OngageUnsubscribe
